import React from 'react';
import styles from '../../styles/GestionUsuariosStyles/GestionUsuarios.module.css';

function UserDetailModal({ isOpen, onClose, userData }) {
  if (!isOpen || !userData) return null;

  const getCampusNames = () => {
    if (!userData.campus_asignados || userData.campus_asignados.length === 0) {
      return 'Ninguno';
    }
    // Si tenemos los nombres directamente
    if (Array.isArray(userData.campus_asignados) && typeof userData.campus_asignados[0] === 'string') {
      return userData.campus_asignados.join(', ');
    }
    // Si tenemos objetos con nombre
    if (Array.isArray(userData.campus_asignados) && userData.campus_asignados[0]?.nombre) {
      return userData.campus_asignados.map(c => c.nombre).join(', ');
    }
    return userData.campus || 'No asignado';
  };

  const getSeccionesNames = () => {
    if (!userData.secciones_asignadas || userData.secciones_asignadas.length === 0) {
      return 'Ninguna';
    }
    // Si tenemos los nombres directamente
    if (Array.isArray(userData.secciones_asignadas) && typeof userData.secciones_asignadas[0] === 'string') {
      return userData.secciones_asignadas;
    }
    // Si tenemos objetos con nombre
    if (Array.isArray(userData.secciones_asignadas) && userData.secciones_asignadas[0]?.nombre) {
      return userData.secciones_asignadas.map(s => s.nombre);
    }
    return [];
  };

  const secciones = getSeccionesNames();

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.detailModalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.detailModalHeader}>
          <h2>Detalles del Usuario</h2>
        </div>

        <div className={styles.detailModalBody}>
          <div className={styles.detailRow}>
            <div className={styles.detailLabel}>Nombre Completo</div>
            <div className={styles.detailValue}>
              {userData.nombre} {userData.apellidos || ''}
            </div>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.detailLabel}>Usuario</div>
            <div className={styles.detailValue}>{userData.usuario || '-'}</div>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.detailLabel}>Contraseña</div>
            <div className={styles.detailValue}>
              •••••
              <button className={styles.eyeButton} title="Ver contraseña">
                👁️
              </button>
            </div>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.detailLabel}>Email Institucional</div>
            <div className={styles.detailValue}>
              {userData.email_institucional || userData.emailInstitucional || '-'}
            </div>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.detailLabel}>Institución</div>
            <div className={styles.detailValue}>
              {userData.institucion_nombre || userData.institucion || '-'}
            </div>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.detailLabel}>Campus asignado(s)</div>
            <div className={styles.detailValue}>
              <span className={styles.campusChip}>{getCampusNames()}</span>
            </div>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.detailLabel}>Secciones Asignadas</div>
            <div className={styles.detailValue}>
              <div className={styles.seccionesChips}>
                {Array.isArray(secciones) && secciones.length > 0 ? (
                  secciones.map((seccion, index) => (
                    <span key={index} className={styles.seccionChip}>
                      {typeof seccion === 'string' ? seccion : seccion.nombre}
                    </span>
                  ))
                ) : (
                  <span className={styles.seccionChip}>Ninguna</span>
                )}
              </div>
            </div>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.detailLabel}>Rol</div>
            <div className={styles.detailValue}>{userData.rol || '-'}</div>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.detailLabel}>Estado</div>
            <div className={styles.detailValue}>
              <span className={userData.estado === 'ACTIVO' ? styles.statusActive : styles.statusInactive}>
                {userData.estado || 'INACTIVO'}
              </span>
            </div>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.detailLabel}>Fecha de creación</div>
            <div className={styles.detailValue}>
              {userData.fecha_creacion || userData.fechaCreacion || '-'}
            </div>
          </div>

          <div className={styles.detailRow}>
            <div className={styles.detailLabel}>Último acceso</div>
            <div className={styles.detailValue}>
              {userData.ultimo_acceso || userData.ultimoAcceso || 'Nunca'}
            </div>
          </div>
        </div>

        <div className={styles.detailModalActions}>
          <button className={styles.closeButton} onClick={onClose}>
            CERRAR
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserDetailModal;
